import FileDropzone from './file-dropzone';
import GalleryPreferences from './gallery-preferences';

export default {
  props: ['coursework', 'coursework_entry'],

  template: '#file_uploader_template',

  data() {
    return {
      dzInstances: [],
      entryIds: [],
      fieldCount: {},
      uploading: false,
      descriptionValid: true
    };
  },

  components: {
    'file-dropzone': FileDropzone,
    'gallery-preferences': GalleryPreferences
  },

  computed: {
    submissionText() {
      return this.uploading ? 'Uploading...' : `Submit ${I18n.t('dict.assignment')}`;
    }
  },

  methods: {
    addFieldEntryId(field_id, field_entry_id) {
      this.entryIds.push(field_entry_id);
      this.fieldCount[field_id] = (this.fieldCount[field_id] || 0) + 1;
    },

    removeFieldEntryId(field_id, field_entry_id) {
      if (this.entryIds.splice(this.entryIds.indexOf(field_entry_id), 1).length > 0) {
        this.fieldCount[field_id] = (this.fieldCount[field_id] || 0) - 1;
      }
    },

    submit() {
      if (this.uploading)
        return;

      this.$validator.validateAll();

      let self = this;
      let dzInvalid = _.any(this.dzInstances, function (dz) { return !dz.isValid(); });
      let notesValid = !this.errors.has('notes');
      let descriptionValid = this.descriptionValid;

      let reqFieldsSubmitted = _.every(this.coursework_entry.coursework_fields, function(field) {
        if(field.required || (self.fieldCount[field.id] && self.fieldCount[field.id] > 0)) {
          let reqCount = (field.min_files_required ? field.min_files_required : 1);
          return self.fieldCount[field.id] >= reqCount;
        } else {
          return true;
        }
      }, 0);

      if (!dzInvalid && notesValid && descriptionValid && reqFieldsSubmitted) {
        let data = {coursework_entry: this.coursework_entry};

        if (this.coursework.group.submitted && !this.coursework.group.self_submitted) {
          delete data.coursework_entry.id;
        }

        delete data.coursework_entry.coursework_fields;
        data.coursework_entry.coursework_field_entry_ids = self.entryIds;
        this.$parent.submitCourseworkEntry(data, '#js-file-uploader');
      } else if (!reqFieldsSubmitted) {
        new Kadenze.Notice.error({ message: 'Please make sure you have uploaded the required number of files for all the fields.' });
      } else if (dzInvalid) {
        new Kadenze.Notice.error({ message: 'Please make sure all files are valid.' });
      } else if (!notesValid) {
        new Kadenze.Notice.error({ message: 'Please limit the notes for our graders to 600 characters.' });
      } else if (!descriptionValid) {
        new Kadenze.Notice.error({ message: 'Please limit the gallery description to 1200 characters.' });
      }
    },

    cancel() {
      this.$parent.coursework.is_submitting = false;
    }
  },

  mounted() {
    Kadenze.UIUtil.initExpandableTextareas();
  }
};
